import React, { useEffect, useRef, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export function Splash() {
  return (
    <div className="flex min-h-[100dvh] flex-col items-center justify-center gap-5 bg-[#0B111E]" data-testid="loading-splash">
      <img src="/logo-mark.webp" alt="Send-Proof" className="h-[92px] w-[92px] rounded-[22px]" />
      <div className="text-center">
        <div className="font-heading text-[27px] font-extrabold tracking-tight text-white">Send-Proof</div>
        <div className="mt-1.5 text-sm text-slate-400">Proof it got done.</div>
      </div>
    </div>
  );
}

export function ProtectedRoute({ children, requireSub = false }) {
  const { user, loading, refresh } = useAuth();
  const { search } = useLocation();
  const [syncing, setSyncing] = useState(search.includes("checkout=success"));
  const tried = useRef(false);

  useEffect(() => {
    if (!search.includes("checkout=success") || tried.current) return;
    tried.current = true;
    let cancelled = false;
    (async () => {
      const { api } = await import("@/lib/api");
      for (let i = 0; i < 6; i++) {
        try { await api.post("/billing/sync"); } catch { /* ignore */ }
        const u = await refresh();
        if (u?.subscription?.active) break;
        await new Promise((r) => setTimeout(r, 1500));
      }
      if (!cancelled) setSyncing(false);
    })();
    return () => { cancelled = true; };
  }, [search, refresh]);

  if (loading || syncing) return <Splash />;
  if (!user) return <Navigate to="/auth?mode=signin" replace />;
  if (requireSub && !user.subscription?.active) return <Navigate to="/onboarding" replace />;
  return children;
}
